import React from "react";

// Shows the last-known app build version so support can tell which build a
// device is on. Truncated to 7 chars, matching the source app's convention
// for git-SHA-style versions - see
// docs/implementation-plans/2026-09-29-app-version-update-banner.md.
const VersionLabel = ({ version, className, colorClassName }) => {
  if (!version) return null;

  return (
    <div className={`${colorClassName || "text-canvas-sidebar opacity-70"} text-[11px] font-outfit ${className || ""}`}>
      Version {version.slice(0, 7)}
    </div>
  );
};

export default VersionLabel;
